import React, {Component} from 'react';
import './Textarea.css';

export default class Textarea extends Component{
	constructor(props) {
		super(props);
		this.myRefs = {};
	}
	isValid = () => {
		return true;
	};

	getValue = () => {
		return this.myRefs.input.value;
	};
  render() {
    return(
    <div className="g-textarea">
			<textarea ref={(ref) => (this.myRefs.input = ref)} placeholder={this.props.placeholder} />
    </div>
    )
  }
}